import {
  InitOrderProductsParams,
  InitSectionsParams,
} from '../interfaces/orderProducts.helper.interfaces';
import { OrderHeadersGroupByEnum, OrderProduct, Section } from '../orderProducts.types';
import OrderProductsGroupByFactory from './groupBy/OrderProductsGroupByFactory';
import { emptyDefaultSection } from './orderProductsHelpers.utils';
import OrderProductsSorterFactory from './sorter/OrderProductsSorterFactory';

export const initSections = ({
  products,
  view,
  viewInfo,
  orderProductsWithErrors,
}: InitSectionsParams): Section[] => {
  const orderProductsGroupBy = new OrderProductsGroupByFactory().create(view);
  const orderProductsSorter = new OrderProductsSorterFactory().create(view);
  const sections = orderProductsGroupBy.group({
    orderProducts: products,
    info: viewInfo,
    orderProductsWithErrors,
  });

  if (view[0] === OrderHeadersGroupByEnum.DEFAULT) {
    return orderProductsSorter.sort({ orderProducts: sections });
  }
  return [
    emptyDefaultSection,
    ...orderProductsSorter.sort({
      orderProducts: sections,
      orderProductsWithErrors,
      info: viewInfo,
    }),
  ];
};

export const initOrderProducts = ({
  products,
  view,
  orderProductsWithErrors,
  viewInfo,
}: InitOrderProductsParams): OrderProduct[] => {
  const newProducts = products.map((product) => ({
    ...product,
    subCategory: product.category,
  }));
  const orderProductsSorter = new OrderProductsSorterFactory().create(view);
  return orderProductsSorter.sort({
    orderProducts: newProducts,
    orderProductsWithErrors,
    info: viewInfo,
  });
};
